import {Component, Input, OnInit} from '@angular/core';
import {TransactionTypeCode} from '@app/services/transactionTypes/transaction-type-code';
import {TransactionTypeService} from '@app/services/transactionTypes/transaction-type.service';
import {DcpError} from '@dcp/configurator';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {Product} from '@spartacus/core/src/model/product.model';
import {combineLatest, Observable} from 'rxjs';
import {first} from 'rxjs/operators';
import {DcpProductUtilitiesService} from '../../../../services/dcp-product-utilities.service';
import {ProductPageDecoratorService} from '../../../../services/product-page-decorator.service';
import {ConfiguratorProductService} from '../../../services/configurator-product.service';
import {ActionTypeSelectStrategyService} from '@app/services/action-type-select-strategy/action-type-select-strategy.service';

/**
 * Error-page representing the 'VAL_0302' - 'Customer already has CPEA' Error
 */
@UntilDestroy()
@Component({
  selector: 'dcp-add-to-existing-contract-error',
  templateUrl: './add-to-existing-contract-error.component.html',
  styleUrls: ['./add-to-existing-contract-error.component.scss']
})
export class AddToExistingContractErrorComponent implements OnInit {
  @Input() error: DcpError;

  displayProduct$: Observable<Product>;
  variantProduct$: Observable<Product>;
  productCode: string;

  constructor(
    private actionTypeSelectStrategyService: ActionTypeSelectStrategyService,
    private configuratorProductService: ConfiguratorProductService,
    private productPageDecoratorService: ProductPageDecoratorService,
    private dcpProductUtilitiesService: DcpProductUtilitiesService,
    private transactionTypeService: TransactionTypeService,
  ) {
  }

  ngOnInit(): void {
    this.displayProduct$ = this.configuratorProductService.getDisplay$();
    this.variantProduct$ = this.configuratorProductService.getVariant$();
  }

  /**
   * Opens the configurator page or lead form according to the transactionTypes settings.
   *
   * @param product Current product
   */
  openConfigurator(product: Product) {
    combineLatest([
      this.transactionTypeService.getTransactionTypes$(),
      this.productPageDecoratorService.getCtaProductDetermination(product)
    ]).pipe(first(), untilDestroyed(this))
      .subscribe(([transactionTypes, productDetermination]) => {
        const transactionType = transactionTypes.find(transactionType => this.error?.cta?.code === transactionType.code || TransactionTypeCode.ORDER_UPSELL === transactionType.code);
        const entitlement = this.productPageDecoratorService.getEntitlementFromProductDeterminationCtaByCanonicalId(
          productDetermination, this.dcpProductUtilitiesService.getCanonicalId(product, null)
        );
        const transactionListCta = this.error?.cta || this.productPageDecoratorService.getCallToActionByCode(transactionType.code, entitlement.callToActions);
        const actionTypeContext = this.actionTypeSelectStrategyService.selectStrategy(
          transactionType,
          product,
          transactionListCta,
          null
        );
        actionTypeContext.exec();
      });
  }
}
